<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'MentionsLegales'
});
</script>
<template>
  <ka-container code="mentions-legales">
    <ka-text code="text-1">
      <h1 v-html="t('mentionsLegales.text1.value', `Mentions légales`)" />
    </ka-text>
    <!-- Pourquoi Matchers ? -->
    <ka-container code="pourquoi-matchers">
      <!-- switcher -->
      <ka-container code="switcher">
        <!-- Textes -->
        <ka-container code="textes">
          <ka-text
            code="edition-du-site-internet"
            :options="{
              style: { color: `#0090ADFF` },
              click: page.editionDuSiteInternetClick,
              $state: { selected: page.$elements['image']?.value?.trim() === page.$constants.imageValue?.trim() && page.$elements['pour-les-entreprises']?.value?.trim() === page.$constants.pourLesEntreprisesValue?.trim() && page.$elements['switch-texte']?.value?.trim() === page.$constants.switchTexteValue?.trim() && $isEqual(page.$elements['edition-du-site-internet']?.style.color, page.$constants.texte1Color) }
            }">
            <h2 v-html="t('mentionsLegales.pourquoiMatchers.switcher.textes.editionDuSiteInternet.value', `Édition du site internet`)" />
          </ka-text>
          <ka-text
            code="texte-2"
            :options="{
              click: page.texte2Click,
              $state: { selected: $isEqual(page.$elements['edition-du-site-internet']?.style.color, page.$constants.texte1Color1) && $isEqual(page.$elements['edition-du-site-internet']?.style.fontWeight, page.$constants.texte1FontWeight) && page.$elements['image']?.value?.trim() === page.$constants.imageValue1?.trim() && page.$elements['pour-les-entreprises']?.value?.trim() === page.$constants.pourLesEntreprisesValue1?.trim() && page.$elements['switch-texte']?.value?.trim() === page.$constants.switchTexteValue1?.trim() }
            }">
            <h2 v-html="t('mentionsLegales.pourquoiMatchers.switcher.textes.texte2.value', `Hébergeur du site internet`)" />
          </ka-text>
          <ka-text
            code="texte-3"
            :options="{
              click: page.texte3Click,
              $state: { selected: $isEqual(page.$elements['edition-du-site-internet']?.style.color, page.$constants.texte1Color2) && $isEqual(page.$elements['edition-du-site-internet']?.style.fontWeight, page.$constants.texte1FontWeight) && page.$elements['image']?.value?.trim() === page.$constants.imageValue2?.trim() && page.$elements['pour-les-entreprises']?.value?.trim() === page.$constants.pourLesEntreprisesValue2?.trim() && page.$elements['switch-texte']?.value?.trim() === page.$constants.switchTexteValue2?.trim() }
            }">
            <h2 v-html="t('mentionsLegales.pourquoiMatchers.switcher.textes.texte3.value', `Respect de la propriété intellectuelle`)" />
          </ka-text>
          <ka-text
            code="texte-4"
            :options="{
              click: page.texte4Click,
              $state: { selected: $isEqual(page.$elements['edition-du-site-internet']?.style.color, page.$constants.texte1Color2) && $isEqual(page.$elements['edition-du-site-internet']?.style.fontWeight, page.$constants.texte1FontWeight) && page.$elements['image']?.value?.trim() === page.$constants.imageValue3?.trim() && page.$elements['pour-les-entreprises']?.value?.trim() === page.$constants.pourLesEntreprisesValue3?.trim() && page.$elements['switch-texte']?.value?.trim() === page.$constants.switchTexteValue3?.trim() }
            }">
            <h2 v-html="t('mentionsLegales.pourquoiMatchers.switcher.textes.texte4.value', `Crédits photographiques et iconographiques`)" />
          </ka-text>
          <ka-text
            code="texte-5"
            :options="{
              click: page.texte5Click,
              $state: { selected: $isEqual(page.$elements['edition-du-site-internet']?.style.color, page.$constants.texte1Color2) && $isEqual(page.$elements['edition-du-site-internet']?.style.fontWeight, page.$constants.texte1FontWeight) && page.$elements['image']?.value?.trim() === page.$constants.imageValue3?.trim() && page.$elements['pour-les-entreprises']?.value?.trim() === page.$constants.pourLesEntreprisesValue4?.trim() && page.$elements['switch-texte']?.value?.trim() === page.$constants.switchTexteValue4?.trim() }
            }">
            <h2 v-html="t('mentionsLegales.pourquoiMatchers.switcher.textes.texte5.value', `Liens hypertextes`)" />
          </ka-text>
          <ka-text
            code="texte-6"
            :options="{
              click: page.texte6Click,
              $state: { selected: $isEqual(page.$elements['edition-du-site-internet']?.style.color, page.$constants.texte1Color2) && $isEqual(page.$elements['edition-du-site-internet']?.style.fontWeight, page.$constants.texte1FontWeight) && page.$elements['image']?.value?.trim() === page.$constants.imageValue3?.trim() && page.$elements['pour-les-entreprises']?.value?.trim() === page.$constants.pourLesEntreprisesValue5?.trim() && page.$elements['switch-texte']?.value?.trim() === page.$constants.switchTexteValue5?.trim() }
            }">
            <h2 v-html="t('mentionsLegales.pourquoiMatchers.switcher.textes.texte6.value', `Collectes des données`)" />
          </ka-text>
          <ka-text
            code="texte-7"
            :options="{
              click: page.texte7Click,
              $state: { selected: $isEqual(page.$elements['edition-du-site-internet']?.style.color, page.$constants.texte1Color2) && $isEqual(page.$elements['edition-du-site-internet']?.style.fontWeight, page.$constants.texte1FontWeight) && page.$elements['image']?.value?.trim() === page.$constants.imageValue3?.trim() && page.$elements['pour-les-entreprises']?.value?.trim() === page.$constants.pourLesEntreprisesValue6?.trim() && page.$elements['switch-texte']?.value?.trim() === page.$constants.switchTexteValue6?.trim() }
            }">
            <h2 v-html="t('mentionsLegales.pourquoiMatchers.switcher.textes.texte7.value', `Cookies`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <ka-separator code="separateur" />
      <!-- article -->
      <ka-container code="article">
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Experts et entreprises, rejoignez dès maintenant Matchers et bénéficiez d'avantages essentiels `
          }"
          value="https://ucarecdn.com/3a67e841-5f56-42e4-8ca7-1c6532ddbd5c/" />
        <!-- Conteneur -->
        <ka-container code="conteneur">
          <ka-text code="pour-les-entreprises">
            <h2 v-html="t('mentionsLegales.pourquoiMatchers.article.conteneur.pourLesEntreprises.value', `Édition du site internet`)" />
          </ka-text>
          <!-- Container -->
          <ka-container
            code="container"
            :data="page.$info.container">
            <ka-text code="switch-texte">
              <span v-html="t('mentionsLegales.pourquoiMatchers.article.conteneur.container.switchTexte.value', `<span style='font-size:17px;'>La protection des données personnelles est un enjeu important pour Matchers, c’est pour cela que nous nous engageons à mettre tout en œuvre pour respecter la confidentialité de vos données. Par conséquent, les informations collectées ne sont pas revendues à des tiers. </span><br> `)" />
            </ka-text>
          </ka-container>
        </ka-container>
      </ka-container>
    </ka-container>
    <!-- Conteneur -->
    <ka-container
      code="container-1"
      inner>
      <!-- Textes -->
      <ka-container code="container-2">
        <ka-text code="vous-avez-des-questions">
          <span v-html="t('mentionsLegales.container1.container2.vousAvezDesQuestions.value', `Vous avez des questions ?`)" />
        </ka-text>
        <ka-text code="vous-voulez-parler">
          <span v-html="t('mentionsLegales.container1.container2.vousVoulezParler.value', `Vous voulez parler plan de formation ? Vous avez des questions sur notre fonctionnement ? Vous avez du mal à définir précisément votre besoin ?`)" />
        </ka-text>
      </ka-container>
      <!-- Boutons -->
      <ka-container code="boutons">
        <ka-button
          code="prendre-rendez-vous"
          :options="{
            ripple: true,
            href: `https://www.matchers.fr/faq`,
            ariaLabel: `prendre rendez vous`,
            click: page.prendreRendezVousClick,
            hidden: null
          }">
          <span v-html="t('mentionsLegales.container1.boutons.prendreRendezVous.value', `Voir la F.A.Q`)" />
        </ka-button>
        <ka-button
          code="button-1"
          :options="{
            ripple: true,
            href: { name: `Contact` },
            click: page.button1Click
          }">
          <span v-html="t('mentionsLegales.container1.boutons.button1.value', `Contactez-nous`)" />
        </ka-button>
      </ka-container>
    </ka-container>
    <!-- Conteneur 1 -->
    <ka-container
      code="conteneur-1"
      :options="{ hidden: null }">
      <!-- Conteneur 2 -->
      <ka-container code="conteneur-2">
        <ka-text code="titre-de-larticle">
          <span v-html="t('mentionsLegales.conteneur1.conteneur2.titreDeLarticle.value', `Titre de l’article<br>Titre de l’article`)" />
        </ka-text>
        <ka-text code="lorem-ipsum-dolor-sit">
          <span v-html="t('mentionsLegales.conteneur1.conteneur2.loremIpsumDolorSit.value', `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`)" />
        </ka-text>
        <ka-text code="top-3-de-nos-articles">
          <span v-html="t('mentionsLegales.conteneur1.conteneur2.top3DeNosArticles.value', `TOP 3 DE NOS ARTICLES<br> `)" />
        </ka-text>
        <ka-text-link
          code="lien"
          value="Lire l’article >" />
      </ka-container>
      <!-- Conteneur 1 -->
      <ka-container code="container-3">
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image`
          }"
          value="https://ucarecdn.com/c680c61d-1e1f-4489-8f50-8981a977b28b/" />
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { mentionsLegales } from './store'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p23')
const appData = appDataStore()
const page = mentionsLegales()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
